export default class ActivityFilters {
  public page?: number = null;
  public limit?: number = null;

  constructor(filters: any) {
    this.page = filters.page ? filters.page : null;
    this.limit = filters.limit ? filters.limit : null;
  }
}
